import {
  createInventorizationIssue,
  INVENTORIZATION_BLOCK_IDS,
  readInventorizationBlockStatus,
} from '@/features/inventorization/domain/inventorization';
import type { InventorizationIdentity } from '@/features/inventorization/domain/inventorization-identity';
import type { BlockStatus, ValidationIssue } from '@/shared/capture/capture-session';
import { translateInventoryText } from '@/shared/i18n/inventory-i18n';

export function validateInventorizationIdentity(identity: InventorizationIdentity): ValidationIssue[] {
  const issues: ValidationIssue[] = [];
  const blockId = INVENTORIZATION_BLOCK_IDS.identity;

  if (!(identity.newMeter || identity.serial.trim())) {
    issues.push(
      createInventorizationIssue(
        blockId,
        'IDENTITY_SERIAL_MISSING',
        translateInventoryText('app.inventory.validation.identity.serialRequired', 'Serial number is required.'),
      ),
    );
  }

  if (!identity.apiKey.trim()) {
    issues.push(
      createInventorizationIssue(
        blockId,
        'IDENTITY_API_KEY_MISSING',
        translateInventoryText('app.inventory.validation.identity.apiKeyRequired', 'QR/API key is required.'),
      ),
    );
  }

  if (!identity.placement) {
    issues.push(
      createInventorizationIssue(
        blockId,
        'IDENTITY_PLACEMENT_MISSING',
        translateInventoryText('app.inventory.validation.identity.placementRequired', 'Placement is required.'),
      ),
    );
  }

  if (!identity.commodity) {
    issues.push(
      createInventorizationIssue(
        blockId,
        'IDENTITY_COMMODITY_MISSING',
        translateInventoryText('app.inventory.validation.identity.commodityRequired', 'Commodity is required.'),
      ),
    );
  }

  return issues;
}

export function getInventorizationIdentityBlockStatus(identity: InventorizationIdentity): BlockStatus {
  return readInventorizationBlockStatus(validateInventorizationIdentity(identity));
}
